<template>
  <div>
    <PageAllow
      controller="MaterialTemplates"
      :action="savable ? 'batchSave' : 'viewByTemplate'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="materialKeyword = $event"
              :label="$t('MaterialTemplate.priceTypes.filterHint')"
            />
          </v-row>
        </v-col>
        <!-- 按钮 -->
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              v-if="template.id && savable && !settings.is_ban_add_template_materials"
              small
              dark
              color="primary"
              @click.stop="selectMaterialsDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
            <!-- 导出 -->
            <v-btn
              small
              v-if="
                template.id &&
                !savable &&
                $permission.permissionAllow('MaterialTemplates', 'export')
              "
              color="print"
              dark
              @click="exportsDetail()"
            >
              <v-icon x-small class="px-1">fa-file-export</v-icon>
              {{ $t("Export.export", []) }}
            </v-btn>
            <v-btn
              small
              v-if="!savable"
              color="primary"
              @click="mode = 'edit'"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
              {{ $t("CRUD.edit") }}
            </v-btn>
            <v-btn
              outlined
              small
              v-if="savable"
              color="secondary"
              @click="mode = 'view'"
              class="ms-1 elevation-1"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.abandon") }}
            </v-btn>
            <v-btn
              small
              v-if="savable"
              color="success"
              @click="saveTemplateMaterials()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{ $t("CRUD.save") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategoriesWithDescendants
              v-model="categorySelecteds"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialShowCategoriesWithDescendants v-model="showCategoriesSelected" />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <SearcherSelect
            ref="brand"
            v-model="options.brand"
            :items="material_brands"
            :label="$t('Material.Fields.brand')"
          />
        </v-col>
        <!-- 商品关联集 -->
        <v-col
          v-if="this.settings && this.settings.material_group_enable"
          cols="12"
          sm="6"
          md="3"
        >
          <SearcherSelect
            ref="material_group"
            v-model="options.material_group"
            :items="material_groups"
            :label="$t('Material.Fields.material_group')"
          />
        </v-col>
      </v-row>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="template_details"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="
            stickTableCols
              ? settings && settings.sub_account_enable
                ? 'sticky-first-col  sticky-last-col'
                : 'sticky-first-col'
              : ''
          "
          fixed-header
          :footer-props="footerProps"
        >
          <template v-slot:body.prepend>
            <tr v-if="template.id && savable" class="d-none d-sm-table-row">
              <td></td>
              <td></td>
              <td></td>
              <td align="center" class="pt-3 pb-2">
                <v-select
                  dense
                  hide-details
                  :label="$t('MaterialTemplate.priceTypeAll')"
                  placeholder="-"
                  style="
                    max-width: 140px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  :items="
                    settings && settings.sub_account_enable
                      ? priceTypesSelect.slice(0, 1)
                      : priceTypesSelect
                  "
                  item-text="text"
                  item-value="value"
                  v-model="priceTypeAll"
                />
              </td>
              <td></td>
              <td align="end" v-if="checkPriceType">
                <v-text-field
                  v-if="
                    (priceTypeAll == 4 && priceTypeCount.length > 0) ||
                    priceTypeAll == 2 ||
                    priceTypeAll == 3
                  "
                  single-line
                  dense
                  hide-details
                  v-model="floatUpPercentAll"
                  type="number"
                  min="0"
                  suffix="%"
                  @blur="
                    floatUpPercentAll =
                      $numberFormatter.formatWithDotNoMoreThan(
                        floatUpPercentAll,
                        2
                      )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
                <!-- 暂时隐掉 -->
                <v-btn
                  small
                  text
                  color="info"
                  class="px-0"
                  style="display: none"
                >
                  <v-icon x-small class="pe-1">fa-file-import</v-icon>
                  {{
                    $t("Import.import", [
                      $t("MaterialTemplate.Fields.supply_price"),
                    ])
                  }}
                </v-btn>
              </td>
              <td>
                <v-select
                  dense
                  hide-details
                  placeholder="-"
                  style="
                    max-width: 140px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  :items="unitSettingSelect"
                  item-text="text"
                  item-value="value"
                  clearable
                  v-model="unitSettingAll"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="multipleAll"
                  type="number"
                  min="0"
                  @blur="
                    multipleAll = $numberFormatter.formatWithDotNoMoreThan(
                      multipleAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="minNumAll"
                  type="number"
                  min="0"
                  @blur="
                    minNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      minNumAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
               <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="maxNumAll"
                  type="number"
                  min="0"
                  @blur="
                    maxNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      maxNumAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.hide_flg != hideAll
                    )
                      ? true
                      : false
                  "
                  v-model="hideAll"
                  :true-value="0"
                  :false-value="1"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.hideAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                v-if="settings && !settings.sub_account_enable"
                class="align-center"
              >
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.is_follow != followAll
                    )
                      ? true
                      : false
                  "
                  v-model="followAll"
                  :true-value="false"
                  :false-value="true"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.followAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find((detail) => detail.valid != validAll)
                      ? true
                      : false
                  "
                  v-model="validAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.valid_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                v-if="
                  settings &&
                  settings.sub_account_enable &&
                  settings.sub_account_enable != 2
                "
              ></td>
              <td
                class="align-center"
                v-if="settings && settings.material_group_enable"
              ></td>
              <td
                class="align-center"
                v-if="settings && settings.material_group_enable"
              >
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.material_group_flg != materialGroupAll
                    )
                      ? true
                      : false
                  "
                  v-model="materialGroupAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.materialGroupAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td v-if="settings && settings.service_charge_enable">
                <v-text-field
                  v-if="savable"
                  single-line
                  dense
                  hide-details
                  v-model="serviceChargePercentAll"
                  type="number"
                  min="0"
                  suffix="%"
                  @blur="
                    serviceChargePercentAll =
                      $numberFormatter.formatWithDotNoMoreThan(
                        serviceChargePercentAll,
                        2
                      )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
            </tr>
            <tr
              v-else-if="template.id == 0 && savable"
              class="d-none d-sm-table-row"
            >
              <td></td>
              <td colspan="5"></td>
              <td
                v-if="
                  accountInfo &&
                  (accountInfo.account_id == '0210116' ||
                    accountInfo.account_id == '0210117')
                "
              ></td>
              <td colspan="2"></td>
              <td>
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.hide_flg != hideAll
                    )
                      ? true
                      : false
                  "
                  v-model="hideAll"
                  :true-value="0"
                  :false-value="1"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.hideAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.public_flg != publicFlgAll
                    )
                      ? true
                      : false
                  "
                  v-model="publicFlgAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.public_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                class="align-center"
                v-if="settings && settings.material_group_enable"
              ></td>
              <td
                class="align-center"
                v-if="settings && settings.material_group_enable"
              >
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find(
                      (detail) => detail.material_group_flg != materialGroupAll
                    )
                      ? true
                      : false
                  "
                  v-model="materialGroupAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.materialGroupAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td v-if="settings && settings.service_charge_enable">
                <v-text-field
                  v-if="savable"
                  single-line
                  dense
                  hide-details
                  v-model="serviceChargePercentAll"
                  type="number"
                  min="0"
                  suffix="%"
                  @blur="
                    serviceChargePercentAll =
                      $numberFormatter.formatWithDotNoMoreThan(
                        serviceChargePercentAll,
                        2
                      )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
            </tr>
            <tr v-if="template.id && savable" class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.price_type") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-select
                    dense
                    hide-details
                    :label="$t('MaterialTemplate.priceTypeAll')"
                    placeholder="-"
                    style="
                      max-width: 200px;
                      margin-left: auto;
                      margin-right: auto;
                    "
                    :items="
                      settings && settings.sub_account_enable
                        ? priceTypesSelect.slice(0, 1)
                        : priceTypesSelect
                    "
                    item-text="text"
                    item-value="value"
                    v-model="priceTypeAll"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.supply_price") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-btn text color="info" class="px-0">
                    <v-icon x-small class="pe-1">fa-file-import</v-icon>
                    {{
                      $t("Import.import", [
                        $t("MaterialTemplate.Fields.supply_price"),
                      ])
                    }}
                  </v-btn>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.supply_percentage") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    v-if="
                      (priceTypeAll == 4 && priceTypeCount.length > 0) ||
                      priceTypeAll == 2 ||
                      priceTypeAll == 3
                    "
                    single-line
                    dense
                    hide-details
                    v-model="floatUpPercentAll"
                    type="number"
                    min="0"
                    suffix="%"
                    @blur="
                      floatUpPercentAll =
                        $numberFormatter.formatWithDotNoMoreThan(
                          floatUpPercentAll,
                          2
                        )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.unit") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-select
                    dense
                    hide-details
                    placeholder="-"
                    style="
                      max-width: 140px;
                      margin-left: auto;
                      margin-right: auto;
                    "
                    :items="unitSettingSelect"
                    item-text="text"
                    item-value="value"
                    clearable
                    v-model="unitSettingAll"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.multiple") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="multipleAll"
                    type="number"
                    min="0"
                    @blur="
                      multipleAll = $numberFormatter.formatWithDotNoMoreThan(
                        multipleAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.min_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="minNumAll"
                    type="number"
                    min="0"
                    @blur="
                      minNumAll = $numberFormatter.formatWithDotNoMoreThan(
                        minNumAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.max_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="maxNumAll"
                    type="number"
                    min="0"
                    @blur="
                      maxNumAll = $numberFormatter.formatWithDotNoMoreThan(
                        maxNumAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.hide_flg") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.hide_flg != hideAll
                      )
                        ? true
                        : false
                    "
                    v-model="hideAll"
                    :true-value="0"
                    :false-value="1"
                    :label="$t('MaterialTemplate.hideAll')"
                  ></v-checkbox>
                </div>
              </td>
              <td
                v-if="!settings.sub_account_enable"
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.is_follow") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.is_follow != followAll
                      )
                        ? true
                        : false
                    "
                    v-model="followAll"
                    :label="$t('MaterialTemplate.followAll')"
                    :true-value="false"
                    :false-value="true"
                  ></v-checkbox>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("Material.templates.usable") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.valid != validAll
                      )
                        ? true
                        : false
                    "
                    v-model="validAll"
                    :label="$t('MaterialTemplate.valid_all')"
                  ></v-checkbox>
                </div>
              </td>
              <td
                class="v-data-table__mobile-row"
                v-if="settings && settings.service_charge_enable"
              >
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.service_charge_percent") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    v-if="savable"
                    single-line
                    dense
                    hide-details
                    v-model="serviceChargePercentAll"
                    type="number"
                    min="0"
                    suffix="%"
                    @blur="
                      serviceChargePercentAll =
                        $numberFormatter.formatWithDotNoMoreThan(
                          serviceChargePercentAll,
                          2
                        )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
            </tr>
            <tr
              v-else-if="template.id == 0 && savable"
              class="d-table-row d-sm-none"
            >
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.hide_flg") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.hide_flg != hideAll
                      )
                        ? true
                        : false
                    "
                    v-model="hideAll"
                    :true-value="0"
                    :false-value="1"
                    :label="$t('MaterialTemplate.hideAll')"
                  ></v-checkbox>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.public_all") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.public_flg != publicFlgAll
                      )
                        ? true
                        : false
                    "
                    v-model="publicFlgAll"
                    :label="$t('MaterialTemplate.public_all')"
                  ></v-checkbox>
                </div>
              </td>
              <td
                class="v-data-table__mobile-row"
                v-if="settings && settings.service_charge_enable"
              >
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.service_charge_percent") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    v-if="savable"
                    single-line
                    dense
                    hide-details
                    v-model="serviceChargePercentAll"
                    type="number"
                    min="0"
                    suffix="%"
                    @blur="
                      serviceChargePercentAll =
                        $numberFormatter.formatWithDotNoMoreThan(
                          serviceChargePercentAll,
                          2
                        )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:header.split_price="{ header }">
            <span v-if="settings && settings.sub_account_split_type">
              {{ $t("MaterialTemplate.splitPrices.percent") }}
            </span>
            <span v-else>
              {{ header.text }}
            </span>
          </template>

          <template v-slot:item.Description="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small>
                  {{ item.hide_flg ? "fa-eye-slash" : "fa-eye" }}</v-icon
                >{{
                  $t(
                    settings
                      ? settings.material_name_display_type == 3
                        ? "Material.materialNameWithCodeAndStandard"
                        : settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                        : "Material.materialName"
                      : "Material.materialName",
                    [item.material_code, item.material_name, item.standard_name]
                  )
                }}
              </template>
              <span>
                {{
                  item.hide_flg
                    ? $t("Material.hideFlgs.on")
                    : $t("Material.hideFlgs.off")
                }}
              </span>
            </v-tooltip> -->
            <div class="d-inline-block ma-1">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="d-block text-truncate"
                    style="max-width: 430px; cursor: pointer"
                    >{{ item.material_name }}
                  </span>
                </template>
                {{ item.material_name }}
              </v-tooltip>
              <span class="caption secondary--text">
                {{ item.material_code }}
              </span>
            </div>
          </template>
          <template v-slot:item.price_type="{ item }">
            <div v-if="template.id && savable">
              <v-select
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                style="max-width: 160px; margin-left: auto; margin-right: auto"
                :items="
                  settings && settings.sub_account_enable
                    ? priceTypesSelect.slice(0, 1)
                    : priceTypesSelect
                "
                item-text="text"
                item-value="value"
                :value="0"
              />
              <v-select
                v-else
                single-line
                dense
                hide-details
                style="max-width: 160px; margin-left: auto; margin-right: auto"
                :items="
                  settings && settings.sub_account_enable
                    ? priceTypesSelect.slice(0, 1)
                    : priceTypesSelect
                "
                item-text="text"
                item-value="value"
                v-model="item.price_type"
              />
            </div>
            <span v-else>
              {{ priceTypeText(item) }}
            </span>
          </template>
          <template v-slot:item.in_price="{ item }">
            <v-text-field
              single-line
              v-model="item.in_price"
              type="number"
              min="0"
              @blur="
                item.in_price = $numberFormatter.formatMoney(item.in_price)
              "
              :prefix="$t('Global.money')"
              v-if="savable"
            />

            <span v-else>
              {{ $t("Global.money") }} {{ item.in_price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.standard="{ item }">
            <span v-if="template && template.id">
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
            <span v-else>
              <v-text-field
                single-line
                v-if="item && item.standard && savable"
                v-model="item.standard.name"
              />
              <span v-else>
                <span v-if="item.standard && item.standard.name && item.standard.name.length > 12" :title="item.standard.name" style="cursor: pointer">
                  {{ item.standard.name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                {{ item && item.standard ? item.standard.name : "" }}
                </span>
              </span>
            </span>
          </template>
          <template v-slot:item.supply_price="{ item }">
            <div v-if="savable">
              <v-text-field
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                :value="item.material.supply_price"
                :prefix="$t('Global.money')"
                style="max-width: 100px; margin-left: auto"
              />
              <v-text-field
                v-else-if="!item.price_type"
                single-line
                dense
                hide-details
                v-model="item.supply_price"
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.supply_price = $numberFormatter.formatWithDotNoMoreThan(
                    item.supply_price,
                    2
                  )
                "
                style="max-width: 100px; margin-left: auto"
              />
              <v-btn
                v-else-if="item.price_type == 1"
                small
                text
                color="info"
                class="ps-8 pe-0"
                @click="lastPriceFor = item"
              >
                {{ $t("Opt.details") }}
              </v-btn>
              <span v-else-if="item.price_type == 3">
                {{ $t("Global.money") }}
                {{ item.last_in_price_calculate | formatMoney }} ({{
                  $t("MaterialTemplate.Fields.after_float_up")
                }})
              </span>
              <span v-else-if="item.price_type == 2">
                {{ $t("Global.money") }}
                {{ item.stock_cost_price_calculate | formatMoney }} ({{
                  $t("MaterialTemplate.Fields.after_float_up")
                }})
              </span>
              <span v-else-if="item.price_type == 4">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text-no-wrap my-0"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ $t("Global.money") }}
                      {{ item.float_up_price | formatMoney }}
                    </span>
                  </template>
                  <span>{{ $t("MaterialTemplate.floatUpPriceTooltip") }}</span>
                </v-tooltip>
              </span>
              <span v-else>-</span>
            </div>
            <div v-else>
              <span v-if="!item.price_type">
                {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
              </span>
              <v-btn
                v-else-if="item.price_type == 1"
                small
                text
                color="info"
                @click="lastPriceFor = item"
              >
                {{ $t("Opt.details") }}
              </v-btn>
              <span v-else-if="item.price_type == 3">
                {{ $t("Global.money") }}
                {{ item.last_in_price_calculate | formatMoney }} ({{
                  $t("MaterialTemplate.Fields.after_float_up")
                }})
              </span>
              <span v-else-if="item.price_type == 2">
                {{ $t("Global.money") }}
                {{ item.stock_cost_price_calculate | formatMoney }} ({{
                  $t("MaterialTemplate.Fields.after_float_up")
                }})
              </span>
              <span v-else-if="item.price_type == 4">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="my-0"
                      :class="
                        $vuetify.theme.dark
                          ? 'text--lighten-1'
                          : 'text--darken-1'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ $t("Global.money") }}
                      {{ item.float_up_price | formatMoney }}
                    </span>
                  </template>
                  <span>{{ $t("MaterialTemplate.floatUpPriceTooltip") }}</span>
                </v-tooltip>
                <!-- <br />
                <span
                  class="text-no-wrap caption secondary--text my-0"
                  :class="
                    $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                  "
                >
                  {{ item.float_up_percent }} %
                </span> -->
              </span>
            </div>
          </template>
          <template v-slot:item.float_up_price="{ item }">
            <div v-if="savable">
              <v-text-field
                v-if="item.price_type == 2"
                single-line
                dense
                hide-details
                v-model="item.cost_price_percent"
                type="number"
                min="0"
                suffix="%"
                @blur="
                  item.cost_price_percent =
                    $numberFormatter.formatWithDotNoMoreThan(
                      item.cost_price_percent,
                      2
                    )
                "
                style="max-width: 100px; margin-left: auto"
              />
              <v-text-field
                v-else-if="item.price_type == 3"
                single-line
                dense
                hide-details
                v-model="item.batch_price_percent"
                type="number"
                min="0"
                suffix="%"
                @blur="
                  item.batch_price_percent =
                    $numberFormatter.formatWithDotNoMoreThan(
                      item.batch_price_percent,
                      2
                    )
                "
                style="max-width: 100px; margin-left: auto"
              />
              <v-text-field
                v-else-if="item.price_type == 4"
                single-line
                dense
                hide-details
                v-model="item.float_up_percent"
                type="number"
                min="0"
                suffix="%"
                @blur="
                  item.float_up_percent =
                    $numberFormatter.formatWithDotNoMoreThan(
                      item.float_up_percent,
                      2
                    )
                "
                style="max-width: 100px; margin-left: auto"
              />

              <span v-else>-</span>
            </div>
            <div v-else>
              <span v-if="item.price_type == 2">
                {{ item.cost_price_percent }} %
              </span>
              <span v-else-if="item.price_type == 4">
                {{ item.float_up_percent }} %
              </span>
              <span v-else-if="item.price_type == 3">
                {{ item.batch_price_percent }} %
              </span>
              <span v-else>-</span>
            </div>
          </template>
          <template v-slot:item.unit="{ item }">
            <div v-if="savable">
              <v-select
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                style="max-width: 60px; margin-right: auto; margin-left: auto"
                :items="item.standard_details"
                item-text="unit"
                item-value="id"
                :value="item.material.supply_standard_detail_id"
              />
              <v-select
                v-else
                single-line
                dense
                hide-details
                style="max-width: 60px; margin-right: auto; margin-left: auto"
                :items="item.standard_details"
                item-text="unit"
                item-value="id"
                v-model="item.standard_detail_id"
              />
              <div
                v-if="
                  item.select_standard_detail &&
                  item.select_standard_detail.rate > 1
                "
                class="mt-n5"
              >
                <br />
                <span class="caption secondary--text">
                  (1{{ item.select_standard_detail.unit }}={{
                    item.select_standard_detail.rate
                  }}{{ item.default_unit }})
                </span>
              </div>
            </div>
            <span v-else>
              {{ item.unit }}
            </span>
          </template>
          <template v-slot:item.material_supply_price="{ item }">
            <span v-if="item.price_type == 4">
              {{ $t("Global.money")
              }}{{ item.default_order_price | formatMoney }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.multiple="{ item }">
            <div v-if="savable">
              <v-text-field
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                v-model="item.material.multiple"
                class="input-center"
                style="max-width: 60px; margin-left: auto"
              />
              <v-text-field
                v-else
                single-line
                dense
                hide-details
                v-model="item.multiple"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.multiple = $numberFormatter.formatWithDotNoMoreThan(
                    item.multiple,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.multiple | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.min_num="{ item }">
            <div v-if="savable">
              <v-text-field
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                v-model="item.material.min"
                class="input-center"
                style="max-width: 60px; margin-left: auto"
              />
              <v-text-field
                v-else
                single-line
                dense
                hide-details
                v-model="item.min_num"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.min_num = $numberFormatter.formatWithDotNoMoreThan(
                    item.min_num,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.min_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.max_num="{ item }">
            <div v-if="savable">
              <v-text-field
                v-if="item.is_follow"
                disabled
                single-line
                dense
                hide-details
                v-model="item.material.max"
                class="input-center"
                style="max-width: 60px; margin-left: auto"
              />
              <v-text-field
                v-else
                single-line
                dense
                hide-details
                v-model="item.max_num"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.max_num = $numberFormatter.formatWithDotNoMoreThan(
                    item.max_num,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.max_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.valid="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.valid"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.valid
                          ? "Material.templates.usable_on"
                          : "Material.templates.usable_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.public_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3" v-if="savable">
              <v-checkbox
                color="primary"
                v-model="item.public_flg"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.public_flg
                          ? "Material.publicFlgs.on"
                          : "Material.publicFlgs.off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
            <span class="caption ms-n2" v-else>
              {{
                $t(
                  item.public_flg
                    ? "Material.publicFlgs.on"
                    : "Material.publicFlgs.off"
                )
              }}
            </span>
          </template>
          <template v-slot:item.material_group_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3" v-if="savable">
              <v-checkbox
                color="primary"
                v-model="item.material_group_flg"
                :disabled="
                  item.material_group == null || item.material_group == ''
                    ? true
                    : false
                "
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.material_group_flg
                          ? "MaterialTemplate.Fields.material_group_on"
                          : "MaterialTemplate.Fields.material_group_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
            <span class="caption ms-n2" v-else>
              {{
                $t(
                  item.material_group_flg
                    ? "MaterialTemplate.Fields.material_group_on"
                    : "MaterialTemplate.Fields.material_group_off"
                )
              }}
            </span>
          </template>
          <template v-slot:item.hide_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3" v-if="savable">
              <v-checkbox
                color="primary"
                v-model="item.hide_flg"
                :true-value="0"
                :false-value="1"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.hide_flg
                          ? "MaterialTemplate.Fields.hide_on"
                          : "MaterialTemplate.Fields.hide_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
            <span class="caption ms-n2" v-else>
              {{
                $t(
                  item.hide_flg
                    ? "MaterialTemplate.Fields.hide_on"
                    : "MaterialTemplate.Fields.hide_off"
                )
              }}
            </span>
          </template>
          <template v-slot:item.is_follow="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.is_follow"
                :true-value="false"
                :false-value="true"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.is_follow
                          ? "MaterialTemplate.Fields.follow_on"
                          : "MaterialTemplate.Fields.follow_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.split_price="{ item }">
            <v-btn
              v-if="item.price_type == 0"
              small
              text
              color="info"
              @click="splitPriceItem = item"
            >
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
          <template v-slot:item.service_charge_percent="{ item }">
            <v-text-field
              v-if="savable"
              single-line
              dense
              hide-details
              v-model="item.service_charge_percent"
              type="number"
              min="0"
              suffix="%"
              @blur="
                item.service_charge_percent =
                  $numberFormatter.formatWithDotNoMoreThan(
                    item.service_charge_percent,
                    2
                  )
              "
              style="max-width: 100px; margin-left: auto"
            />
            <span v-else> {{ item.service_charge_percent }} % </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <LastPrice v-model="lastPriceFor" />
    <SplitPrice
      v-model="splitPriceItem"
      :mode="mode"
      :bank_code="template.sub_account_pay_type"
      :price="splitPriceItem ? Number(splitPriceItem.supply_price) : 0"
      percent
    />
    <SelectTemplateMaterials
      v-model="selectMaterialsDialog"
      :changed="changedDetails"
      @confirm="
        changedDetails = $event;
        if (options.page == 1) getTemplateMaterialsFromAPI();
        else options.page = 1;
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import LastPrice from "./plugins/LastPrice";
import SplitPrice from "./plugins/SplitPrice";
import SelectTemplateMaterials from "./plugins/SelectAllTemplateMaterials";
import MaterialTemplates from "@/api/material_templates";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import Materials from "@/api/materials";
import SearcherMaterialShowCategoriesWithDescendants from "@/components/plugins/SearcherMaterialShowCategoriesWithDescendants";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherMaterialCategoriesWithDescendants,
    LastPrice,
    SplitPrice,
    SelectTemplateMaterials,
    SearcherSelect,
    SearcherMaterialShowCategoriesWithDescendants,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialTemplates"),
          disabled: false,
          href: "/templates",
        },
        {
          text: this.savable
            ? i18n.t("Nav.materialTemplatePriceSet")
            : i18n.t("Nav.materialTemplateDetail"),
          disabled: true,
        },
        {
          text:
            this.template && this.template.template_name
              ? this.template.template_name
              : i18n.t("Nav.materialTemplateDetail"),
          disabled: false,
          accent: true,
        },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("MaterialTemplate.Fields.material"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.material_category"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.standard"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "standard",
        },
      ];
      if (this.template && this.template.id) {
        headers.push(
          {
            text: i18n.t("MaterialTemplate.Fields.price_type"),
            align: "center",
            sortable: false,
            filterable: false,
            value: "price_type",
          },
          {
            text: i18n.t("MaterialTemplate.Fields.supply_price"),
            align: "end",
            sortable: false,
            filterable: false,
            value: "supply_price",
          }
        );
        if (this.checkPriceType) {
          headers.push({
            text: i18n.t("MaterialTemplate.Fields.supply_percentage"),
            align: "end",
            sortable: false,
            filterable: false,
            value: "float_up_price",
          });
        }
        headers.push({
          text: i18n.t("MaterialTemplate.Fields.unit"),
          align: "center",
          sortable: false,
          filterable: true,
          value: "unit",
        });
      } else {
        headers.push(
          {
            text: i18n.t("MaterialTemplate.Fields.supply_price"),
            align: "end",
            sortable: false,
            filterable: false,
            value: "supply_price",
          },
          {
            text: i18n.t("MaterialTemplate.Fields.in_price"),
            align: "center",
            sortable: false,
            filterable: false,
            value: "in_price",
          },
          {
            text: i18n.t("MaterialTemplate.Fields.unit"),
            align: "center",
            sortable: false,
            filterable: true,
            value: "unit",
          }
        );
      }

      if (
        this.accountInfo &&
        (this.accountInfo.account_id == "0210116" ||
          this.accountInfo.account_id == "0210117")
      ) {
        headers.push({
          text: i18n.t("MaterialTemplate.Fields.default_price"),
          align: "center",
          width: "100",
          sortable: false,
          filterable: true,
          value: "material_supply_price",
        });
      }
      headers.push(
        {
          text: i18n.t("MaterialTemplate.Fields.multiple"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "multiple",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.min_num"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "min_num",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.max_num"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "max_num",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.hide_flg"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "hide_flg",
        }
      );

      if (this.template && this.template.id) {
        if (this.settings && this.settings.sub_account_enable) {
          if (this.savable) {
            headers.push({
              text: i18n.t("Material.templates.usable"),
              align: "start",
              sortable: false,
              filterable: false,
              value: "valid",
            });
          }
          if (this.settings && this.settings.sub_account_enable != 2) {
            headers.push({
              text: i18n.t("MaterialTemplate.Fields.split_price"),
              align: "center",
              sortable: false,
              filterable: false,
              value: "split_price",
            });
          }
        } else if (this.savable) {
          headers.push({
            text: i18n.t("MaterialTemplate.Fields.is_follow"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "is_follow",
          });
          headers.push({
            text: i18n.t("Material.templates.usable"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "valid",
          });
        }
      }
      if (this.template && this.template.id == 0) {
        headers.push({
          text: i18n.t("Material.templates.publicFlg"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          filterable: false,
          value: "public_flg",
        });
      }
      if (this.settings && this.settings.material_group_enable) {
        headers.push({
          text: i18n.t("MaterialTemplate.priceTypes.materialGroup"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "material_group",
        });
        headers.push({
          text: i18n.t("MaterialTemplate.Fields.material_group_flg"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "material_group_flg",
        });
      }
      if (this.settings && this.settings.service_charge_enable) {
        headers.push({
          text: i18n.t("MaterialTemplate.Fields.service_charge_percent"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "service_charge_percent",
        });
      }
      return headers;
    },
    priceTypesSelect: () => [
      { value: 0, text: i18n.t("MaterialTemplate.priceTypes.custom") },
      { value: 1, text: i18n.t("MaterialTemplate.priceTypes.lastPrice") },
      { value: 2, text: i18n.t("MaterialTemplate.priceTypes.costPercent") },
      { value: 3, text: i18n.t("MaterialTemplate.priceTypes.lastInPrice") },
      { value: 4, text: i18n.t("MaterialTemplate.priceTypes.supplyPrice") },
    ],
    unitSettingSelect: () => [
      {
        value: 1,
        text: i18n.t("MaterialTemplate.unitSettings.defaultUnitAll"),
      },
      { value: 2, text: i18n.t("MaterialTemplate.unitSettings.maxUnitAll") },
    ],
    footerProps() {
      var props = i18n.t("$config.footer-props");
      props.itemsPerPageOptions.push(-1);
      return props;
    },
    checkPriceType() {
      if (this.template_details.find((detail) => detail.price_type != 0)) {
        return true;
      }
      return false;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols", "accountInfo"]),
  },

  mounted() {
    Materials.fetchFiledSelects({
      field_names: ["material_group", "brand"],
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.material_brands = response.data.brand;
          if (this.$route.params.id == 0) {
            this.material_groups = response.data.material_group;
          } else {
            this.getMaterialGroups();
          }
        }
      }.bind(this)
    );
    this.mode = this.$route.params.mode;
    if (this.mode) this.$router.replace("/templates/" + this.$route.params.id);
  },

  data: () => ({
    mode: "",
    materialKeyword: "",
    categorySelecteds: [],
    showCategoriesSelected: [],
    material_groups: [],
    options: {
      keyword: "",
      category_ids: [],
      show_category_ids: [],
      readonly: 1,
      status: [1], // 只获取生效的
      page: 1,
      sortBy: [],
      sortDesc: [],
    },
    paging: {},
    priceTypeAll: -1,
    priceTypeCount: [],
    floatUpPercentAll: "",
    unitSettingAll: 0,
    multipleAll: "",
    minNumAll: "",
    maxNumAll:"",
    serviceChargePercentAll: "",
    validAll: 1,
    publicFlgAll: 1,
    followAll: false,
    hideAll: 0,
    materialGroupAll: 0,
    template: {},
    template_details: [],
    changedDetails: [],
    lastPriceFor: null,
    selectMaterialsDialog: false,
    splitPriceItem: null,
    material_brands: [],
  }),

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.materialKeyword,
      });
    },
    resetSearch() {
      this.options = {
        keyword: "",
        category_ids: [],
        show_category_ids: [],
        readonly: 1,
        status: [1], // 只获取生效的
        page: 1,
        sortBy: [],
        sortDesc: [],
      }
      if (this.isView) {
        this.materialKeyword = "";
        this.categorySelecteds = [];
        this.showCategoriesSelected = [];
        this.changedDetails = [];
        this.priceTypeAll = -1;
        this.validAll = 1;
        this.publicFlgAll = 1;
        this.followAll = false;
        this.hideAll = 0;
        this.materialGroupAll = 0;
        this.options.readonly = 1;
      } else {
        this.options.readonly = 0;
      }
      this.changedDetails = []; // 模式变化时清空已编辑数组
    },
    priceTypeText(item) {
      var priceType = this.priceTypesSelect.find(
        (type) => type.value == (item.price_type ? item.price_type : 0)
      );
      return priceType ? priceType.text : "-";
    },
    getTemplateMaterialsFromAPI() {
      if (this.savable) this.$store.dispatch("fullscreenLoading");
      MaterialTemplates.fetchByTemplate(
        this.$route.params.id,
        Object.assign({}, this.options, {
          itemsPerPage:
            this.options.itemsPerPage == -1
              ? this.$consts.limitAll
              : this.options.itemsPerPage,
          unsaved: this.changedDetails
            .filter((d) => !d.status)
            .map((d) => d.id),
        })
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.template = response.data.template;
              this.template_details = response.data.template_details.map(
                (item) => {
                  var changedDetail = this.changedDetails.find(
                    (s) =>
                      (this.template.id && s.id == item.id) ||
                      (!this.template.id && s.material_id == item.material_id)
                  );
                  if (changedDetail) return changedDetail;
                  item.supply_price =
                    this.$numberFormatter.formatWithDotNoMoreThan(
                      item.supply_price,
                      2
                    );
                  //成本百分比
                  item.cost_price_percent =
                    this.$numberFormatter.formatWithDotNoMoreThan(
                      Number(item.cost_price_percent) - 100,
                      2
                    );

                  if (item.price_type == 2) {
                    //成本价百分比,换算成基准单位价格
                    let standard_detail = item.standard_details.find(
                      (d) => d.id == item.standard_detail_id
                    );
                    if (standard_detail) {
                      item.stock_cost_price =
                        this.$numberFormatter.formatTwoDot(
                          Number(item.stock_cost_price) /
                            Number(standard_detail.rate)
                        );
                    }
                  }
                  // 计算商品的要货单价
                  item.default_order_price =
                    Number(item.material_supply_price) /
                    (item.material_supply_standard
                      ? Number(item.material_supply_standard.rate)
                      : 1);
                  item.float_up_percent = Number(item.float_up_percent);

                  item.multiple = Number(item.multiple);
                  item.min_num = Number(item.min_num);
                  item.max_num = Number(item.max_num);
                  item.valid = item.status;

                  item.standard_details = item.standard_details
                    ? item.standard_details
                    : [];
                  item.select_standard_detail = item.standard_details.find(
                    (s) =>
                      s.id == item.is_follow
                        ? item.material.supply_standard_detail_id
                        : item.standard_detail_id
                  );
                  item.price_type_default = item.price_type; //保存初始价格类型

                  item.material_group_flg =
                    item.material_group_flg == null
                      ? 0
                      : item.material_group_flg;
                  return item;
                }
              );
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      this.getMaterialGroups();
    },
    saveTemplateMaterials() {
      this.$store.dispatch("fullscreenLoading");
      var data = this.changedDetails
        .filter(
          (detail) =>
            !this.template_id || // 默认模板全部都要保存
            detail.valid || // 非默认模板保存生效的商品
            detail.status != detail.valid // 以及生效状态改变的商品
        )
        .map(
          function (detail) {
            let detailData = {
              id: detail.id,
              material_id: detail.material_id,
              min_num: detail.min_num,
              max_num: detail.max_num,
              multiple: detail.multiple,
              price_type: detail.price_type,
              supply_price: detail.supply_price,
              cost_price_percent: detail.cost_price_percent,
              batch_price_percent: detail.batch_price_percent,
              float_up_percent: detail.float_up_percent,
              standard_detail_id: detail.standard_detail_id,
              is_follow: detail.is_follow,
              sub_account_price_json: detail.sub_account_price_json,
              status: detail.valid,
              hide_flg: detail.hide_flg,
              in_price: detail.in_price,
              material_group_flg: detail.material_group_flg,
            };
            if (this.settings && this.settings.service_charge_enable) {
              detailData.service_charge_percent = detail.service_charge_percent;
            }
            if (detail.standard) {
              detailData.standard_name = detail.standard.name;
            }
            if (!this.template_id) {
              detailData.public_flg = detail.public_flg;
            }
            return detailData;
          }.bind(this)
        );
      MaterialTemplates.batchSave(data, 1)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.mode = "view";
              this.options.page = 1;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
    exportsDetail() {
      MaterialTemplates.exportsDetail(
        this.$route.params.id,
        Object.assign({}, this.options, {
          itemsPerPage:
            this.options.itemsPerPage == -1
              ? this.$consts.limitAll
              : this.options.itemsPerPage,
          unsaved: this.changedDetails
            .filter((d) => !d.status)
            .map((d) => d.id),
        })
      );
    },
    getMaterialGroups() {
      if (this.$route.params.id != 0) {
        MaterialTemplates.getTemplatesMaterialGroups(
          this.$route.params.id,
          Object.assign({}, this.options, {
            itemsPerPage:
              this.options.itemsPerPage == -1
                ? this.$consts.limitAll
                : this.options.itemsPerPage,
            unsaved: this.changedDetails
              .filter((d) => !d.status)
              .map((d) => d.id),
          })
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.material_groups = response.data.material_group;
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isView) {
          this.materialKeyword = "";
          this.categorySelecteds = [];
          this.showCategoriesSelected = [];
          this.changedDetails = [];
          this.priceTypeAll = -1;
          this.validAll = 1;
          this.publicFlgAll = 1;
          this.followAll = false;
          this.hideAll = 0;
          this.materialGroupAll = 0;
          this.options.readonly = 1;
        } else {
          this.options.readonly = 0;
        }
        this.changedDetails = []; // 模式变化时清空已编辑数组
      },
    },
    categorySelecteds: {
      handler() {
        this.options.category_ids = this.categorySelecteds.map(
          (category) => category.id
        );
      },
    },
    showCategoriesSelected: {
      handler() {
        this.options.show_category_ids = this.showCategoriesSelected.map(
          (showCategory) => showCategory.id
        );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getTemplateMaterialsFromAPI();
      },
    },
    priceTypeAll: {
      handler() {
        if (this.priceTypeAll != -1)
          this.template_details = this.template_details.map(
            function (detail) {
              detail.price_type = this.priceTypeAll;
              return detail;
            }.bind(this)
          );
      },
    },
    floatUpPercentAll: {
      handler() {
        // if (this.priceTypeAll == 4) {
        this.template_details = this.template_details.map(
          function (detail) {
            if (detail.price_type == 4) {
              detail.float_up_percent = this.floatUpPercentAll;
            } else if (detail.price_type == 2) {
              detail.cost_price_percent = this.floatUpPercentAll;
            } else if (detail.price_type == 3) {
              detail.batch_price_percent = this.floatUpPercentAll;
            }

            return detail;
          }.bind(this)
        );
        // }
      },
    },
    unitSettingAll: {
      handler() {
        if (this.unitSettingAll == 1) {
          this.template_details = this.template_details.map((detail) => {
            if (detail.is_follow) {
              detail.material.supply_standard_detail_id =
                detail.standard_details.find((s) => s.default_flg == 1)
                  ? detail.standard_details.find((s) => s.default_flg == 1).id
                  : "";
            } else {
              detail.standard_detail_id = detail.standard_details.find(
                (s) => s.default_flg == 1
              )
                ? detail.standard_details.find((s) => s.default_flg == 1).id
                : "";
            }

            return detail;
          });
        } else if (this.unitSettingAll == 2) {
          this.template_details = this.template_details.map((detail) => {
            if (detail.is_follow) {
              detail.material.supply_standard_detail_id =
                detail.standard_details.find((s) => s.max_unit_flg == 1)
                  ? detail.standard_details.find((s) => s.max_unit_flg == 1).id
                  : "";
            } else {
              detail.standard_detail_id = detail.standard_details.find(
                (s) => s.max_unit_flg == 1
              )
                ? detail.standard_details.find((s) => s.max_unit_flg == 1).id
                : "";
            }

            return detail;
          });
        }
      },
    },
    multipleAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.multiple = this.multipleAll;
            return detail;
          }.bind(this)
        );
      },
    },
    minNumAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.min_num = this.minNumAll;
            return detail;
          }.bind(this)
        );
      },
    },
    maxNumAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.max_num = this.maxNumAll;
            return detail;
          }.bind(this)
        );
      },
    },
    validAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.valid = this.validAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    publicFlgAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.public_flg = this.publicFlgAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    hideAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.hide_flg = this.hideAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    materialGroupAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            if (detail.material_group != null && detail.material_group != "") {
              detail.material_group_flg = this.materialGroupAll ? 1 : 0;
            }
            return detail;
          }.bind(this)
        );
      },
    },
    followAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.is_follow = this.followAll ? true : false;
            return detail;
          }.bind(this)
        );
      },
    },
    serviceChargePercentAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.service_charge_percent = this.serviceChargePercentAll;
            return detail;
          }.bind(this)
        );
      },
    },
    template_details: {
      deep: true,
      handler() {
        if (
          this.template_details.find(
            (detail) => detail.price_type != this.priceTypeAll
          )
        )
          this.priceTypeAll = -1;

        this.template_details.forEach((detail) => {
          //汇总价格类型设置为默认供应商采购价的商品
          if (
            detail.price_type == 4 &&
            this.priceTypeCount.indexOf(detail.material_id) == -1
          ) {
            this.priceTypeCount.push(detail.material_id);
            if (this.floatUpPercentAll)
              detail.float_up_percent = this.floatUpPercentAll;
          }
          //计算新添加的商品的基准单位要货价
          if (!detail.default_order_price) {
            detail.default_order_price =
              Number(detail.material_supply_price) /
              Number(detail.material_supply_standard.rate);
          }
          //默认供应商采购价上浮百分比后的价格动态改变
          if (detail.price_type == 4) {
            //要货价格与要货单位联动
            let standard_detail = detail.standard_details.find(
              (d) => d.id == detail.standard_detail_id
            );
            if (standard_detail) {
              detail.float_up_price =
                detail.price_type == 4
                  ? this.$numberFormatter.formatTwoDot(
                      Number(detail.default_order_price) *
                        Number(standard_detail.rate) *
                        (1 + detail.float_up_percent / 100)
                    )
                  : 1;
            }
          } else if (detail.price_type == 3) {
            //最新入库成本价上浮百分比后的价格动态改变
            let standard_detail = detail.standard_details.find(
              (d) => d.id == detail.standard_detail_id
            );
            if (standard_detail) {
              detail.last_in_price_calculate =
                this.$numberFormatter.formatTwoDot(
                  Number(detail.last_in_price) *
                    Number(standard_detail.rate) *
                    (1 + detail.batch_price_percent / 100)
                );
            }
          } else if (detail.price_type == 2) {
            //成本价百分比
            let standard_detail = detail.standard_details.find(
              (d) => d.id == detail.standard_detail_id
            );
            if (standard_detail) {
              detail.stock_cost_price_calculate =
                this.$numberFormatter.formatTwoDot(
                  Number(detail.stock_cost_price) *
                    Number(standard_detail.rate) *
                    (1 + detail.cost_price_percent / 100)
                );
            }
          }

          if (!this.options.readonly) {
            // 编辑模式下添加到已修改数组里
            var changedDetail = this.changedDetails.find(
              (s) =>
                (this.template.id && s.id == detail.id) ||
                (!this.template.id && s.material_id == detail.material_id)
            );
            if (!changedDetail) this.changedDetails.push(detail);
          }

          //获取当前选择的单位的详情
          if (detail.is_follow) {
            detail.select_standard_detail = detail.standard_details
              ? detail.standard_details.find(
                  (s) => s.id == detail.material.supply_standard_detail_id
                )
              : null;
          } else {
            detail.select_standard_detail = detail.standard_details
              ? detail.standard_details.find(
                  (s) => s.id == detail.standard_detail_id
                )
              : null;
          }
          // 价格类型切换后，成本价百分比变为0
          if (detail.price_type_default != detail.price_type) {
            detail.price_type_default = detail.price_type;
            if (detail.price_type == 2) {
              detail.cost_price_percent = 0;
            }
          }
        }); // 不管是新改变的还是原先就是有效状态的，都添加到changedDetails数组中
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>